<template>
  <div>
    <el-row class="margin-top-lg">
      <el-col :span="24" class="text-right" v-if="simplifyEvBikeInfo.roomId">
        <el-button type="primary" size="small" @click="_addEvBike">
          <i class="el-icon-plus"></i> {{ $t('simplifyEvBike.addBike') }}
        </el-button>
      </el-col>
    </el-row>

    <div class="margin-top">
      <el-table :data="simplifyEvBikeInfo.evBikes" style="width: 100%; margin-top:10px" border>
        <el-table-column prop="carNum" :label="$t('simplifyEvBike.plateNumber')" align="center"></el-table-column>
        <el-table-column prop="carBrand" :label="$t('simplifyEvBike.brandModel')" align="center"></el-table-column>
        <el-table-column prop="ownerName" :label="$t('simplifyEvBike.owner')" align="center"></el-table-column>
        <el-table-column prop="link" :label="$t('simplifyEvBike.phone')" align="center"></el-table-column>
        <el-table-column :label="$t('simplifyEvBike.room')" align="center">
          <template #default="{row}">
            {{ row.roomName || '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyEvBike.status')" align="center">
          <template #default="{row}">
            <span v-if="row.state === '1001'">{{ $t('simplifyEvBike.stateNormal') }}</span>
            <span v-else-if="row.state === '2002'">{{ $t('simplifyEvBike.stateDisable') }}</span>
            <span v-else-if="row.state === '3003'">{{ $t('simplifyEvBike.stateLost') }}</span>
            <span v-else>{{ row.state }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyEvBike.createTime')" align="center">
          <template #default="{row}">
            {{ row.createTime ? row.createTime.substring(0, 16) : '' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('simplifyEvBike.operation')" align="center" width="160">
          <template #default="{row}">
            <el-button type="text" @click="_openEditEvBike(row)">
              {{ $t('simplifyEvBike.edit') }}
            </el-button>
            <el-button type="text" @click="_openDelEvBikeModel(row)">
              {{ $t('simplifyEvBike.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-row>
        <el-col :span="12"></el-col>
        <el-col :span="12" class="text-right">
          <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next" :total="simplifyEvBikeInfo.total"></el-pagination>
        </el-col>
      </el-row>
    </div>

    <edit-car ref="editCar" @success="_refreshList"></edit-car>
    <delete-owner-car ref="deleteOwnerCar" @success="_refreshList"></delete-owner-car>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { queryOwnerCars } from '@/api/simplify/simplifyOwnerCarApi'
import EditCar from '@/components/car/editCar'
import DeleteOwnerCar from '@/components/car/deleteOwnerCar'

const CAR_TYPE_ELECTRIC_BIKE = '9904'
const LEASE_TYPE_TWO_WHEEL = 'E'

export default {
  name: 'SimplifyEvBike',
  components: {
    EditCar,
    DeleteOwnerCar
  },
  data() {
    return {
      simplifyEvBikeInfo: {
        evBikes: [],
        ownerId: '',
        ownerName: '',
        ownerPhone: '',
        roomId: '',
        total: 0,
        records: 1
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
  },
  methods: {
    open(params) {
      this.switchData(params)
    },

    switchData(param) {
      if (!param.roomId || param.roomId === '') return
      this.clearSimplifyEvBikeInfo()
      Object.assign(this.simplifyEvBikeInfo, param)
      this.currentPage = 1
      this._listSimplifyEvBike(1, 10)
    },

    clearSimplifyEvBikeInfo() {
      this.simplifyEvBikeInfo = {
        evBikes: [],
        ownerId: '',
        ownerName: '',
        ownerPhone: '',
        roomId: '',
        total: 0,
        records: 1
      }
      this.currentPage = 1
      this.total = 0
    },

    async _listSimplifyEvBike(page, row) {
      if (!this.simplifyEvBikeInfo.ownerId) {
        return
      }

      try {
        const res = await queryOwnerCars({
          page,
          row,
          ownerId: this.simplifyEvBikeInfo.ownerId,
          communityId: this.communityId,
          leaseType: LEASE_TYPE_TWO_WHEEL,
          carType: CAR_TYPE_ELECTRIC_BIKE,
          carTypeCd: '1001'
        })

        if (res.code != 0) {
          this.$message.error(res.msg)
          return
        }

        this.simplifyEvBikeInfo.evBikes = res.data || []
        this.total = res.total || 0
        this.simplifyEvBikeInfo.total = res.total || 0
        this.simplifyEvBikeInfo.records = res.records || 1
      } catch (error) {
        this.$message.error(error.message || '查询电动车失败')
      }
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this._listSimplifyEvBike(val, this.pageSize)
    },

    _addEvBike() {
      this.$router.push(`/views/car/hireParkingSpace?ownerId=${this.simplifyEvBikeInfo.ownerId}&ownerName=${this.simplifyEvBikeInfo.ownerName}&leaseType=${LEASE_TYPE_TWO_WHEEL}&carType=${CAR_TYPE_ELECTRIC_BIKE}`)
    },

    _openEditEvBike(row) {
      this.$refs.editCar.open(row)
    },

    _openDelEvBikeModel(row) {
      this.$refs.deleteOwnerCar.open(row)
    },

    _refreshList() {
      this._listSimplifyEvBike(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.margin-top-lg {
  margin-top: 20px;
}

.margin-top {
  margin-top: 15px;
}

.padding-right-xs {
  padding-right: 5px;
}

.padding-left-xl {
  padding-left: 20px;
}

.text-right {
  text-align: right;
}
</style>
